var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    { staticClass: "dz-badge" },
    [
      _vm._t("default"),
      _vm.txt === "new"
        ? _c("div", { staticClass: "badge-new", style: _vm.txtStyle })
        : !!_vm.src
        ? _c("img", { style: _vm.txtStyle, attrs: { src: _vm.src } })
        : !!_vm.txt
        ? _c("span", { staticClass: "badge", style: _vm.txtStyle }, [
            _vm._v(_vm._s(_vm.txt)),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }